module.exports = __webpack_public_path__ + "frontend/images/agents/hammers-8ca045269dc8816675eb8d9bc4231eff.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/agents/hammers.png
// module id = 352
// module chunks = 2